import React from 'react';
import { PropTypes } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import './TitleBreadscrumbs.css';
import { useHistory } from 'react-router-dom';

export function TitleBreadscrumbs({ currentPageTitle }) {
  const history = useHistory();

  const secondLevel = currentPageTitle !== 'Início';

  return (
    <div className="titleBreadscrumbs-container">

      {secondLevel && (
        <>
          <div className="iconBox link" onClick={() => history.push('/home')} role="button" tabIndex={0}>
            <FontAwesomeIcon icon={faHouse} />
          </div>
          <span className="iconBox breadcrumb-right">
            <FontAwesomeIcon icon={faChevronRight} />
          </span>
          <span className="titleBreadscrumbs-text">
            {currentPageTitle}
          </span>
        </>
      )}
    </div>
  );
}

TitleBreadscrumbs.propTypes = {
  currentPageTitle: PropTypes.string.isRequired,
};
